module.exports = __webpack_public_path__ + "static/media/trust.1e771962.svg";